import React, { useRef, useEffect, type FC, type JSX } from 'react';
import styled from 'styled-components';
import { useCommonClient } from '@/app/common/commonClientProvider';
import { canUseDOM } from '@/app/common/utils/canUseDOM';
import Days, { type DaysProps } from '../Days';
import MonthButton from '../MonthButton';
import NavArrow, { type NavArrowProps } from '../NavArrow';
import Week from '../Week';

const MonthContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 0;
  min-height: 279px;
  width: 100%;
  margin-bottom: 16px;

  @media only screen and (min-width: 768px) {
    width: 308px;
    min-height: unset;
    border-bottom: none;
    display: block;
  }

  @media (min-width: 768px) {
    .custom-checkin-checkout-modal & {
      margin-bottom: 0;
      overflow: hidden;
    }
  }
`;

type MonthContainerProps = {
  navArrowProps: NavArrowProps;
  monthYear: DaysProps;
};

const MonthContainer: FC<MonthContainerProps> = ({ navArrowProps, monthYear }): JSX.Element => {
  const monthContainerRef = useRef<HTMLDivElement>(null);
  const { isMobile } = useCommonClient();

  useEffect(() => {
    if (monthContainerRef.current && canUseDOM && isMobile) {
      monthContainerRef.current.childNodes.forEach((item) => {
        const el = item as HTMLDivElement;
        const daysContainer = el.classList.contains('openx-ui-calendar-days');
        if (el && daysContainer) {
          if (monthContainerRef.current)
            monthContainerRef.current.style.minHeight = `${el.getBoundingClientRect().height + 44}px`;
        }
      });
    }
  });

  return (
    <MonthContainerStyled ref={monthContainerRef}>
      <NavArrow {...navArrowProps} />
      <MonthButton {...{ ...monthYear }} />
      {!isMobile && <Week />}
      <Days {...{ ...monthYear }} />
    </MonthContainerStyled>
  );
};

export default MonthContainer;
